<template>
  <div v-if="displayTranscription">
    <a
      v-tooltip.left="'View Transcription'"
      href="javascript:;"
      class="transcription-cell__btn"
      @click="toggleTranscription"
    >
      <i class="fa fa-file-text-o" />
    </a>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  computed: {
    displayTranscription() { 
      return this.params.node?.id && this.params.node?.data?.hasTranscription;
    },
  },
  methods: {
    toggleTranscription() {
      this.params.context?.componentParent?.showCallLogDetail(this.params.node, true, 'transcription');
    }
  }
});
</script>